<template>
    <div>
        <dx-grid
            url="YKRecordings"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
            :actions="actions"
        ></dx-grid>
        <v-dialog persistent v-model="updateDialog" max-width="650">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update {{ clickedRow.value }}</v-card-title
                >
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Recording Path:
                    </div>
                    <v-btn
                        v-if="clickedRow.recordingPath"
                        @click="clickedRow.recordingPath = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="clickedRow.recordingPath"
                        controls
                        :src="clickedRow.recordingPath"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile('recordingPath')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="recordingPathFiles"
                        accept="audio/*"
                        @change="onFilePicked($event, 'recordingPath')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Curriculum Path A:
                    </div>
                    <v-btn
                        v-if="clickedRow.curriculumPathA"
                        @click="clickedRow.curriculumPathA = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="clickedRow.curriculumPathA"
                        controls
                        :src="clickedRow.curriculumPathA"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile('curriculumPathA')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="curriculumPathAFiles"
                        accept="audio/*"
                        @change="onFilePicked($event, 'curriculumPathA')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Curriculum Path B:
                    </div>
                    <v-btn
                        v-if="clickedRow.curriculumPathB"
                        @click="clickedRow.curriculumPathB = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="clickedRow.curriculumPathB"
                        controls
                        :src="clickedRow.curriculumPathB"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile('curriculumPathB')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="curriculumPathBFiles"
                        accept="audio/*"
                        @change="onFilePicked($event, 'curriculumPathB')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Curriculum Path C:
                    </div>
                    <v-btn
                        v-if="clickedRow.curriculumPathC"
                        @click="clickedRow.curriculumPathC = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="clickedRow.curriculumPathC"
                        controls
                        :src="clickedRow.curriculumPathC"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile('curriculumPathC')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="curriculumPathCFiles"
                        accept="audio/*"
                        @change="onFilePicked($event, 'curriculumPathC')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Schedule Path:
                    </div>
                    <v-btn
                        v-if="clickedRow.schedulePath"
                        @click="clickedRow.schedulePath = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="clickedRow.schedulePath"
                        controls
                        :src="clickedRow.schedulePath"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile('schedulePath')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="schedulePathFiles"
                        accept="audio/*"
                        @change="onFilePicked($event, 'schedulePath')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="addNewDialog" max-width="650">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">Add New</v-card-title>
                <v-text-field
                    v-model="addNew.value"
                    label="Value"
                    hide-details
                    class="mb-3 width-300"
                ></v-text-field>
                <v-text-field
                    v-model="addNew.discription"
                    label="Description"
                    hide-details
                    class="mb-3 width-300"
                ></v-text-field>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Recording Path:
                    </div>
                    <v-btn
                        v-if="addNew.recordingPath"
                        @click="addNew.recordingPath = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="addNew.recordingPath"
                        controls
                        :src="addNew.recordingPath"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFileNew('recordingPath')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="recordingPathNewFiles"
                        accept="audio/*"
                        @change="onFilePickedNew($event, 'recordingPath')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Curriculum Path A:
                    </div>
                    <v-btn
                        v-if="addNew.curriculumPathA"
                        @click="addNew.curriculumPathA = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="addNew.curriculumPathA"
                        controls
                        :src="addNew.curriculumPathA"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFileNew('curriculumPathA')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="curriculumPathANewFiles"
                        accept="audio/*"
                        @change="onFilePickedNew($event, 'curriculumPathA')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Curriculum Path B:
                    </div>
                    <v-btn
                        v-if="addNew.curriculumPathB"
                        @click="addNew.curriculumPathB = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="addNew.curriculumPathB"
                        controls
                        :src="addNew.curriculumPathB"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFileNew('curriculumPathB')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="curriculumPathBNewFiles"
                        accept="audio/*"
                        @change="onFilePickedNew($event, 'curriculumPathB')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Curriculum Path C:
                    </div>
                    <v-btn
                        v-if="addNew.curriculumPathC"
                        @click="addNew.curriculumPathC = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="addNew.curriculumPathC"
                        controls
                        :src="addNew.curriculumPathC"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFileNew('curriculumPathC')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="curriculumPathCNewFiles"
                        accept="audio/*"
                        @change="onFilePickedNew($event, 'curriculumPathC')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-3 ma-0 pa-0">
                    <div class="font-weight-medium mr-3 pt-3 width-150">
                        Schedule Path:
                    </div>
                    <v-btn
                        v-if="addNew.schedulePath"
                        @click="addNew.schedulePath = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="addNew.schedulePath"
                        controls
                        :src="addNew.schedulePath"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFileNew('schedulePath')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="schedulePathNewFiles"
                        accept="audio/*"
                        @change="onFilePickedNew($event, 'schedulePath')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="addNewDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNew()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";

export default {
    data: () => ({
        title: "YK Recordings",

        actions: [],

        updateDialog: false,
        clickedRow: "",
        processing: false,
        uploading: false,
        files: [],
        actions: [],

        addNewDialog: false,
        addNew: {
            value: "",
            recordingPath: "",
            discription: "",
            curriculumPathA: "",
            curriculumPathB: "",
            curriculumPathC: "",
            schedulePath: "",
        },

        columns: [
            {
                label: "Value",
                field: "value",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Description",
                field: "discription",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "link-audio-cell-template",
                field: "recordingPath",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "CurriculumPathA",
                template: "link-audio-cell-template",
                field: "curriculumPathA",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "CurriculumPathB",
                template: "link-audio-cell-template",
                field: "curriculumPathB",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "CurriculumPathC",
                template: "link-audio-cell-template",
                field: "curriculumPathC",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "SchedulePath",
                template: "link-audio-cell-template",
                field: "schedulePath",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    mounted() {},
    beforeDestroy() {},
    created() {
        this.actions.push({
            text: "Add New",
            action: this.openAddNewDialog,
        });
    },
    methods: {
        onRowClicked(branch) {
            this.clickedRow = JSON.parse(JSON.stringify(branch));
            this.updateDialog = true;
        },
        openAddNewDialog() {
            this.addNew.value = "";
            this.addNew.discription = "";
            this.addNew.recordingPath = "";
            this.addNew.curriculumPathA = "";
            this.addNew.curriculumPathB = "";
            this.addNew.curriculumPathC = "";
            this.addNew.schedulePath = "";

            this.addNewDialog = true;
        },
        pickFile(field) {
            this.$refs[field + "Files"].click();
        },
        pickFileNew(field) {
            this.$refs[field + "NewFiles"].click();
        },
        async onFilePicked(e, field) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/UploadFile?convertMp3=true",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.clickedRow[field] = response.url;
                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async onFilePickedNew(e, field) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/UploadFile?convertMp3=true",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.addNew[field] = response.url;
                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        async save() {
            try {
                this.processing = true;

                await this.$http.post("api/YKRecordings/save", this.clickedRow);

                this.updateDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveNew() {
            if (!this.addNew.value) {
                return this.$notify({
                    group: "notification",
                    text: "Value Is Required",
                    type: "error",
                });
            }
            try {
                this.processing = true;

                await this.$http.post("api/YKRecordings/save", this.addNew);

                this.addNewDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
